import { render, staticRenderFns } from "./ApprovalOfLicenseBorrowingAndReturning.vue?vue&type=template&id=b0f31124&scoped=true&"
import script from "./ApprovalOfLicenseBorrowingAndReturning.vue?vue&type=script&lang=js&"
export * from "./ApprovalOfLicenseBorrowingAndReturning.vue?vue&type=script&lang=js&"
import style0 from "./ApprovalOfLicenseBorrowingAndReturning.vue?vue&type=style&index=0&id=b0f31124&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0f31124",
  null
  
)

export default component.exports